import { LandingTypes } from '@site-builder/common/src/types/model/landing';
import {
  IStoreDRM,
  IStoreItemPrice,
  IStoreVirtualPrice,
  StoreBundle,
  StoreItem,
} from '@site-builder/common/src/types/store';

import { IPriceForStoreItem } from '../../types/store/store-item-price';
import { getCurrencyDisplay } from '../currency-formatter';

export const isGameItem = (type: string) => type === 'gk';

const isHaveDiscount = (price?: IStoreItemPrice) =>
  price && price.amount !== price.amount_without_discount;

const getFromPriceTag = (tagValue: string, price: string) =>
  tagValue.replace('{price}', price);

const countDiscountValue = (
  price?: IStoreItemPrice | IStoreVirtualPrice
): string =>
  price
    ? String(
        -Math.round(
          ((Number(price?.amount_without_discount) - Number(price?.amount)) /
            Number(price?.amount_without_discount)) *
            100
        )
      )
    : '';

const getMinGamePrice = (gameDRMItems: IStoreDRM[]) => {
  if (!Array.isArray(gameDRMItems) || gameDRMItems.length === 0) {
    return false;
  }
  return gameDRMItems
    .map((game) => game.price)
    .sort((aPrice, bPrice) => Number(aPrice.amount) - Number(bPrice.amount))[0];
};

export const getPrice = (
  item: StoreItem,
  type: string,
  landingType: LandingTypes,
  fromPriceTagText: string
): IPriceForStoreItem => {
  const price =
    (isGameItem(type) && getMinGamePrice(item.unit_items)) ||
    item.price ||
    null;
  const priceForStore: IPriceForStoreItem = {};
  const total = (item as StoreBundle).total_content_price;
  if (total) {
    priceForStore.totalPrice = getCurrencyDisplay(total.currency, total.amount);
    priceForStore.savingAmount = String(
      Math.round(
        ((Number(total.amount) - Number(price.amount)) / Number(total.amount)) *
          100
      )
    );
  }
  priceForStore.vcPrice = isGameItem(type)
    ? undefined
    : item.virtual_prices.find((price) => price.amount && price.is_default);

  priceForStore.realPrice =
    item.unit_items?.length > 1
      ? getFromPriceTag(
          fromPriceTagText,
          getCurrencyDisplay(price?.currency, price?.amount)
        )
      : getCurrencyDisplay(price?.currency, price?.amount);
  priceForStore.realWithoutDiscountPrice = getCurrencyDisplay(
    price?.currency,
    price?.amount_without_discount
  );
  const isDiscountWithRealPrice = isHaveDiscount(price);
  const isDiscountWithVirtualPrice = isHaveDiscount(priceForStore.vcPrice);
  priceForStore.hasDiscount =
    isDiscountWithRealPrice || isDiscountWithVirtualPrice;

  if (priceForStore.hasDiscount) {
    priceForStore.discountAmount = countDiscountValue(
      isDiscountWithRealPrice ? price : priceForStore.vcPrice
    );
  }
  if (priceForStore.vcPrice && landingType !== LandingTypes.TOPUP) {
    priceForStore.isForVc = true;
  }
  return priceForStore;
};
